import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "separator"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon = _resolveComponent("icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["v-row window-state-bar", {viewer: _ctx.viewer}])
  }, [
    _renderSlot(_ctx.$slots, "default"),
    (_ctx.viewer)
      ? (_openBlock(), _createBlock(_component_icon, {
          key: 0,
          name: _ctx.isFullScreen ? "fulled-screen" :"full-screen" ,
          onClick: _ctx.setScreenState
        }, null, 8, ["name", "onClick"]))
      : (_openBlock(), _createElementBlock("span", _hoisted_1)),
    _createVNode(_component_icon, {
      name: "minimize",
      onClick: _ctx.minimize
    }, null, 8, ["onClick"]),
    _createVNode(_component_icon, {
      name: _ctx.isMaximized ? "maximized" : "maximize" ,
      onClick: _ctx.maximizeOrRestore
    }, null, 8, ["name", "onClick"]),
    _createVNode(_component_icon, {
      class: "close",
      name: "close",
      onClick: _ctx.closeWindow
    }, null, 8, ["onClick"])
  ], 2))
}